module.exports = tvg.deps['styled-components']['styled-components-6'];